import React, { useContext, useEffect, useState } from "react";
import authService from "../../../components/api-authorization/AuthorizeService";
import tenantConfig from "../../../mocks/tenantOne.json";
import authorization from "../../../mocks/menuPermissions.json";
import { get } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-light-svg-icons";
import { ProgressBarLayout } from "../../../components";
import { MANAGE_FEE_ROUTES, getPathWithParam } from "../../../utils";
import { manageFeeStore } from "../../../contexts";

const ProgressBarFeeContainer = ({ menuList = [], selectedMenu, history }) => {
  const { state, dispatch } = useContext(manageFeeStore);
  const apiData = get(state, "api.data", {});
  const feeId = get(state, "feeId", 0);
  const inprogressStep = get(state, "step", 0) + 1;
  const [roleName, setRoleName] = useState("VOU");
  const [progressBarStatus, setProgressBarStatus] = useState([]);
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  useEffect(() => {
    setProgressBarStatus(
      menuList.map((item, index) => ({
        ...item,
        status:
          item.step == inprogressStep ? 2 : inprogressStep < item.step ? 1 : 3,
      }))
    );
  }, [inprogressStep]);
  return (
    <>
      <div
        className="link blue-small ml-3 mt-3 padding-right-none cursor-pointer"
        onClick={() => {
          history.push(
            getPathWithParam({
              path: MANAGE_FEE_ROUTES.MANAGE_FEE,
            })
          );
        }}
      >
        <FontAwesomeIcon icon={faArrowLeft} /> Back
      </div>
      <div className="manage-fee-column">
        <h5 className="ml-3 mt-3">Create Fee</h5>
        <ul className="manage-fee-menu">
          {progressBarStatus.map((item, index) => {
            const childRoutes = get(item, "childRoutes", []);
            let className =
              selectedMenu.indexOf(item.path) !== -1 ||
              childRoutes.filter((route) => {
                return selectedMenu.indexOf(route) !== -1;
              }).length
                ? "selected"
                : "";
            return (
              tenantConfig.feeSubMenu.includes(item.id) &&
              authorization[roleName].feeSubMenu[item.id] && (
                <ProgressBarLayout
                  index={index}
                  length={progressBarStatus.length}
                  item={item}
                  selectedMenu={className}
                  feeId={feeId}
                />
              )
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default ProgressBarFeeContainer;
